import TopBar from "../../../components/LayoutComponent/TopBar/topBar";
import Tabbar from "../../../components/LayoutComponent/TabBar/Tabbar";
import "../userDashboard.css";
import SubscriptionPayment from "../../../components/userProfileComp/User-Subcription-Form";
import SubscriptionPaymentLink from "../../../components/userProfileComp/User-Subcription-Link";

export const UserSubscriptionPaymentPage = () => {
  return (
    <>
      <div className="w3-content" style={{ minHeight: "400px" }}>
        <TopBar
          showBackButton
          displayType="title"
          title="Subscription"
          showNotification
        ></TopBar>
        <SubscriptionPaymentLink></SubscriptionPaymentLink>
      </div>
    </>
  );
};

export default UserSubscriptionPaymentPage;
